import React from 'react';
import SectionHeading from '../../../Components/Shared/SectionHeading';
// import Swiper core and required modules
import { A11y, EffectFade, Autoplay } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';



// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import Card from '../../../Components/Shared/Card/Card';


import { useSelector } from 'react-redux';



const CovidSection = () => {
    const productList = useSelector((state) => state.cart.allProducts)
    return (
        <div >
            <div className="my-16">
                <SectionHeading text={"Covid-19 Safety Essentials"} />
            </div>


            <div className="">
                <Swiper
                    loop={true}
                    spaceBetween={30}

                    autoplay={{
                        delay: 1000
                    }}
                    modules={[Autoplay, A11y, EffectFade]}
                    breakpoints={{
                        10: {
                            slidesPerView: 1,
                            spaceBetween: 60,
                        },
                        380: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        640: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 30,
                        },
                        1070: {
                            slidesPerView: 6,
                            spaceBetween: 20,
                        },
                    }}
                    className="mySwiper"
                >
                    {productList?.map((product) =>
                        <SwiperSlide key={product._id}>
                            <Card product={product} />
                        </SwiperSlide>
                    )}


                </Swiper>
            </div>



        </div>
    );
};

export default CovidSection;


